import { useDispatch, useSelector } from "react-redux";
import { getErrorMessage } from "../../../utils/errorUtils";
import logger from "../../../utils/logger";

const initialState = {
	actionItems: [],
	showModal: false
};

const actionItemsReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case 'TOGGLE_MODAL':
			return {
				...state,
				showModal: payload.showModal
			};
		case 'LOAD_ACTION_ITEMS':
			return {
				...state,
				actionItems: payload.actionItems
			};
		case 'RESET_ACTION_ITEMS':
			return {
				...state,
				...initialState
			};
		default:
			return state;
	}
};

export const setShowModal = (toggleShowModal) => {
	return async (dispatch) => {
		try {
			dispatch({ type: 'TOGGLE_MODAL', payload: { showModal: toggleShowModal } });
		} catch (error) {
			logger.logReduxErrorEvent(error, getErrorMessage(error), true);
		}
	}
};

export const loadActionItems = (items) => {
	return async (dispatch) => {
		try {
			dispatch({ type: 'LOAD_ACTION_ITEMS', payload: { actionItems: items } });
		} catch (error) {
			logger.logReduxErrorEvent(error, getErrorMessage(error), true);
		}
	}
};

export const resetActionItems = () => {
	return async (dispatch) => {
		try {
			dispatch({ type: 'RESET_ACTION_ITEMS', payload: null });
		} catch (error) {
			logger.logReduxErrorEvent(error, getErrorMessage(error), true);
		}
	}
};

export const useActionItems = () => {
	const dispatch = useDispatch();

	return {
		ActionItemsState: useSelector((appState) => appState.actionItemsState),

		actionItems: useSelector((appState) => appState.actionItemsState.actionItems),
		showModal: useSelector((appState) => appState.actionItemsState.showModal),

		setShowModal: (showModal) => dispatch(setShowModal(showModal)),
		loadActionItems: (actionItems) => dispatch(loadActionItems(actionItems)),
		resetActionItems: () => dispatch(resetActionItems())
	};
};

export default actionItemsReducer;